import { teachersRoutes } from '../features/teachers/routes';
import { authRoutes } from '../features/authentication/routes';
import { lessonPlanRoutes } from '../features/lessonplan/routes';
import { coreLessonPlanRoutes } from '../features/core-lesson-plan/routes';
import { createBrowserRouter } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { examRoutes } from '../features/exam-generator/routes';
import { reportCardRoutes } from '../features/report-card/routes';
import { classRegisterRoutes } from '../features/class-register/routes';
import { examCheckerRoutes } from '../features/exam-checker/routes';
import { userProfileRoutes } from '../features/user-profile/route';
import { communityRoutes } from '../features/community/routes';
import { ParentLayout } from '../components/parent-layout';
import { ErrorBoundaryScreen } from '@taleemabad/dsm/components';
import { analyticsService, EventNames, userCache } from '@taleemabad/db';
import { studentsManagementRoutes } from '../features/students-management/routes';
import { useActiveRolePermission } from '@taleemabad/providers';
import { profileManagementRoutes } from '../features/profiles-management/routes';

import { coachingRoutes } from '../features/coaching/scheduling/routes';
import { coachRoutes } from '../features/coaching/coach/routes';
import { coachingObservationRoutes } from '../features/coaching/observation/routes';
import { schoolManagementRoutes } from '../features/school-management/routes';
import { ProtectedRoute } from '../features/authentication/components/protected-routes';
import { taleemTrackerRoutes } from '../features/taleem-tracker-dashboard/routes';
import { myschoolRoutes } from '../features/myschool/routes';
import { AppRetiredPage } from '../features/retirement/pages/app-retired-page';

const DefaultRoute = () => {
  const activeRolePermissionData = useActiveRolePermission();

  // If no active role permission data, redirect to profile selection
  if (!activeRolePermissionData && !userCache.getActiveProfile()) {
    return <Navigate to="/profile-selection" replace />;
  }

  return (
    <Navigate to={activeRolePermissionData?.defaultRoute ?? '/'} replace />
  );
};

const routes = [
  {
    element: (
      <ErrorBoundaryScreen
        onError={(error: any) => {
          analyticsService.trackEvent(EventNames.UIError, {
            epErrorMessage: error,
          });
        }}
      >
        <ParentLayout />
      </ErrorBoundaryScreen>
    ),
    // APP RETIREMENT — every route resolves to the update notice.
    //
    // This build of the NIETE app is no longer supported; the current one ships
    // on the Play Store. This bundle is the last one this build will ever
    // receive: whichever URL a teacher lands on — a deep link, a push
    // notification, a restored session — they get the same single screen asking
    // them to update. There is nothing to navigate to and no way past it.
    //
    // The feature route modules below are intentionally left imported rather
    // than deleted. Nothing about the app's boot, providers or plugins changes;
    // only the router's destination does. That keeps this diff small, honest
    // and trivially revertible, and it keeps `main.tsx` untouched so Capgo's
    // `notifyAppReady()` still fires within its ~10s window — a bundle that
    // misses it gets rolled back, which would silently undo this notice.
    //
    // NOT wrapped in <ProtectedRoute>: it redirects to /login without a token,
    // and a logged-out teacher must see the retirement notice, not a login form
    // for an app that no longer works.
    //
    // To restore the app: put the spread list below back in place of the single
    // catch-all. The route modules are all still here.
    children: [
      {
        path: '*',
        element: <AppRetiredPage />,
      },
    ],
  },
];
const appRouter = createBrowserRouter(routes);
export default appRouter;
